import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ScheduledActivityCard } from './ScheduledActivityCard';
import type { ScheduledActivityResponse } from '../../types/scheduledActivity';

interface SortableActivityCardProps {
  scheduledActivity: ScheduledActivityResponse;
  onDelete: (sa: ScheduledActivityResponse) => void;
  isDeleting?: boolean;
  isDragDisabled?: boolean;
  viewOnly?: boolean;
}

export function SortableActivityCard({
  scheduledActivity,
  onDelete,
  isDeleting,
  isDragDisabled,
  viewOnly,
}: SortableActivityCardProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: `scheduled-${scheduledActivity.id}`,
    disabled: isDragDisabled,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.3 : 1,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <ScheduledActivityCard
        scheduledActivity={scheduledActivity}
        onDelete={onDelete}
        isDeleting={isDeleting}
        dragHandleProps={{ ...attributes, ...listeners }}
        viewOnly={viewOnly}
      />
    </div>
  );
}
